import React, { useEffect, useRef, useCallback } from 'react';
import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '300px',
};

const defaultCenter = {
  lat: 24.7577,
  lng: 67.4376,
};

interface GoogleMapComponentProps {
  isLoaded: boolean;
  coordinates: { lat: number; lng: number } | null;
  onCoordinatesChange: (lat: number, lng: number) => void;
  fullAddress?: string;
  formik: any;
  inputRef: React.RefObject<HTMLInputElement>;
}

const geocodeAddress = async (address: string): Promise<{ lat: number; lng: number } | null> => {
  const geocoder = new google.maps.Geocoder();
  const result = await geocoder.geocode({ address });
  if (result?.results[0]) {
    const loc = result?.results[0].geometry?.location;
    return { lat: loc.lat(), lng: loc.lng() };
  }
  return null;
};

const reverseGeocode = async (lat: number, lng: number): Promise<string> => {
  const geocoder = new google.maps.Geocoder();
  const result = await geocoder.geocode({ location: { lat, lng } });
  if (result.results[0]) {
    return result.results[0].formatted_address;
  }
  return '';
};

const GoogleMapComponent: React.FC<GoogleMapComponentProps> = ({
  coordinates,
  onCoordinatesChange,
  formik,
  inputRef,
}) => {
  const [mapCenter, setMapCenter] = React.useState(defaultCenter);
  const [markerPosition, setMarkerPosition] = React.useState<{ lat: number; lng: number } | null>(null);

// const { isLoaded } = useJsApiLoader({
//   googleMapsApiKey: 'AIzaSyCMct0m0boGi9OwuQ43XWH8j5xPce0g6rU',
//   libraries: ['places'],
// });

  useEffect(() => {
    // if (!isLoaded) return;

    if (coordinates?.lat && coordinates?.lng) {
      setMapCenter(coordinates);
      setMarkerPosition(coordinates);
    } else {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          setMapCenter(loc);
          setMarkerPosition(loc);
        },
        () => {
          setMapCenter(defaultCenter);
          setMarkerPosition(defaultCenter);
        }
      );
    }
  }, [coordinates]);

const onMapClick = useCallback(
  async (e: google.maps.MapMouseEvent) => {
    if (!e.latLng) return;
    
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    
    const coords = { lat, lng };
    setMarkerPosition(coords);
    onCoordinatesChange(lat, lng);

    formik.setFieldValue('address.coordinates', [lng, lat]);

    const address = await reverseGeocode(lat, lng);

    // Ref input mein show karwana hai
    if (inputRef.current) {
      inputRef.current.value = address;
    }
  },
  [formik, onCoordinatesChange, inputRef]
);



  useEffect(() => {
const handleSearchFromInput = async () => {
  if (inputRef.current && inputRef.current.value) {
    const coords = await geocodeAddress(inputRef.current.value);
    if (coords) {
      setMapCenter(coords);
      setMarkerPosition(coords);
      onCoordinatesChange(coords.lat, coords.lng);
      formik.setFieldValue('address.coordinates', [coords.lng, coords.lat]); // ✅ Correct format
    }
  }
};


    if (inputRef.current) {
      inputRef.current.addEventListener('change', handleSearchFromInput);
    }

    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener('change', handleSearchFromInput);
      }
    };
  }, [inputRef]);

  return  <GoogleMap mapContainerStyle={containerStyle} center={mapCenter} zoom={14} onClick={onMapClick}>
      {markerPosition && <MarkerF position={markerPosition} />}
    </GoogleMap>
};

export default GoogleMapComponent;
